export default {
    async isAvailableAsync() {
        return false;
    },
    startObserving() { },
    stopObserving() { },
};
//# sourceMappingURL=ExponentMagnetometerUncalibrated.web.js.map